import { validateModel } from '@sky-it-livedata-libraries/livedata-commons';
import { ICardDriverRanking } from '@sky-it-livedata/livedata-sports-design-system';
import React, { Suspense } from 'react';

import { IComponentModel } from '../../typings/common-types';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const DataCardMotorsportsDriverRankingWrapper = React.lazy(() => import('./data-card-motorsports-driver-ranking'));

export interface IDynamicDataCardMotorsportsDriverRanking extends IComponentModel<ICardDriverRanking> {
  // eslint-disable-next-line react/require-default-props
  live?: boolean;
}

const DynamicDataCardMotorsportDriverRanking = ({
  /* istanbul ignore next: default value */ model = {} as ICardDriverRanking,
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}: IDynamicDataCardMotorsportsDriverRanking) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <DataCardMotorsportsDriverRankingWrapper
      live={live}
      initialModel={validateModel(model) as ICardDriverRanking}
      query={validateModel(query)}
    />
  </Suspense>
);

export default DynamicDataCardMotorsportDriverRanking;
